import React, { useEffect, useMemo, useState, useCallback } from "react";
import "../parametresStyles/ParamConges.css";
import Swal from "sweetalert2";
import {
    FileText,
    Clock,
    AlertCircle,
    Plus,
    CheckCircle,
    X,
    Edit,
    Trash2,
    Sparkles,
    Calendar,
    Settings,
    Shield,
    FileCheck,
    UserPlus,
    Minus,
    ChevronRight,
    ChevronLeft,
    Check,
    Info,
    ToggleLeft,
    ToggleRight,
    Layers,Eye
} from "lucide-react";
import { useDispatch, useSelector } from "react-redux";

import {
    fetchParamCongesRequest,
    createAbsenceTypeRequest,
    updateAbsenceTypeRequest,
    deleteAbsenceTypeRequest,
    createAcqRuleRequest,
    deleteAcqRuleRequest,
    createJustifRuleRequest,
    deleteJustifRuleRequest,
    updateAcqRuleRequest,
    updateJustifRuleRequest,
    initStandardConfigRequest,
} from "../../../../redux/actions/paramCongesActions";

/* â”€â”€â”€ Wizard step config â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
const WIZARD_STEPS = [
    { id: "base",        label: "Identité",     icon: Settings,   desc: "Nom, code, couleur" },
    { id: "acquisition", label: "Acquisition",  icon: Layers,     desc: "Jours & solde"       },
    { id: "rules",       label: "Règles",       icon: Shield,     desc: "Rémunération & report" },
    { id: "constraints", label: "Restrictions", icon: Calendar,   desc: "Décompte & délais"   },
    { id: "justificatif",label: "Justificatif", icon: FileCheck,  desc: "Documents obligatoires" },
];

/* â”€â”€â”€ Toggle component â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
const Toggle = ({ checked, onChange, label, disabled }) => (
    <button
        type="button"
        className={`pcToggle ${checked ? "is-on" : ""}`}
        onClick={() => !disabled && onChange(!checked)}
        disabled={disabled}
        aria-pressed={checked}
    >
        <span className="pcToggle__thumb" />
        {label && <span className="pcToggle__label">{label}</span>}
    </button>
);

/* â”€â”€â”€ Tooltip component â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
const Tip = ({ text }) => (
    <span className="pcTip" data-tip={text}>
        <Info size={13} />
    </span>
);

const ParamConges = () => {
    const dispatch = useDispatch();

    const { loading, error, typesAbsences, reglesAcquisition, justificatifs } =
        useSelector((state) => state.paramConges || {
            loading: false,
            error: null,
            typesAbsences: [],
            reglesAcquisition: [],
            justificatifs: [],
        });

    const [showModal, setShowModal]   = useState(false);
    const [modalType, setModalType]   = useState("");
    const [formData, setFormData]     = useState({});
    const [editItem, setEditItem]     = useState(null);
    const [wizardStep, setWizardStep] = useState(0);
    const [stepErrors, setStepErrors] = useState({});

    const [viewItem, setViewItem] = useState(null);

    useEffect(() => {
        dispatch(fetchParamCongesRequest());
    }, [dispatch]);


    /* â”€â”€ form helpers â”€â”€ */
    const set = useCallback((key, val) =>
        setFormData(p => ({ ...p, [key]: val })), []);

    const toggle = useCallback((key) =>
        setFormData(p => ({ ...p, [key]: !p[key] })), []);

    /* â”€â”€ open / close modal â”€â”€ */
    const openModal = (type, item = null) => {
        setModalType(type);
        setEditItem(item ? { id: item.id } : null);
        setWizardStep(0);
        setStepErrors({});

        if (!item) {
            setFormData({
                acquisitionMethod: "FIXED",
                balanceType: "ANNUAL",
                methode: "Mensuel",
                dayType: "WORKDAY",
                actif: true,
                couleur: "#204385",
                allowReschedule: true,
                reschedulePolicy: "APRES_VALIDATION",
                noticePeriod: 0,
                negativeBalanceAllowed: false,
                maxNegativeBalance: 0,
                prorataCalculation: false,
                justificationRequired: false,
                justificationMandatory: false,
                perteNonPris: false,
                remunere: false,
                impactAcquisition: false,
                maxDaysPerRequest: null,
                seniorityTiers: [],
                feedingDay: null,
                feedingMonth: null,
            });
        } else {
            if (type === "typeAbsence") {
                setFormData({
                    nom: item.nom ?? "",
                    code: item.code ?? "",
                    description: item.description ?? "",
                    couleur: item.couleur ?? "#204385",
                    nbJours: item.nbJours ?? "",
                    remunere: !!item.remunere,
                    impactAcquisition: !!item.impactAcquisition,
                    actif: !!item.actif,
                    allowReschedule: item.allowReschedule ?? true,
                    reschedulePolicy: item.reschedulePolicy ?? "APRES_VALIDATION",
                    periodeDe: item.periodeDe ?? "",
                    periodeA: item.periodeA ?? "",
                    acquisitionMethod: item.acquisitionMethod ?? "FIXED",
                    balanceType: item.balanceType ?? "ANNUAL",
                    methode: item.methode ?? "Mensuel",
                    joursParPeriode: item.joursParPeriode ?? "",
                    plafondAnnuel: item.plafondAnnuel ?? "",
                    reportMax: item.reportMax ?? "",
                    perteNonPris: !!item.perteNonPris,
                    dayType: item.dayType ?? "WORKDAY",
                    prorataCalculation: !!item.prorataCalculation,
                    justificationRequired: !!item.justificationRequired,
                    justificationType: item.justificationType ?? "",
                    justificationMandatory: !!item.justificationMandatory,
                    noticePeriod: item.noticePeriod ?? 0,
                    negativeBalanceAllowed: !!item.negativeBalanceAllowed,
                    maxNegativeBalance: item.maxNegativeBalance ?? 0,
                    maxDaysPerRequest: item.maxDaysPerRequest ?? "",
                    seniorityTiers: item.seniorityTiers ? [...item.seniorityTiers] : [],
                    feedingDay: item.feedingDay ?? null,
                    feedingMonth: item.feedingMonth ?? null,
                });
            }

        }

        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setModalType("");
        setFormData({});
        setEditItem(null);
        setWizardStep(0);
        setStepErrors({});
    };

    /* â”€â”€ toggle actif â”€â”€ */
    const toggleActif = (type) => {
        dispatch(updateAbsenceTypeRequest(type.id, {
            ...type,
            actif: !type.actif,
            acquisitionMethod: type.acquisitionMethod || "FIXED",
            seniorityTiers: (type.seniorityTiers || []).map(t => ({
                minYears: t.minYears,
                maxYears: t.maxYears,
                days: t.days,
            })),
        }));
    };

    /* â”€â”€ delete â”€â”€ */
    const handleDelete = (type, item) => {
        if (type === "typeAbsence") {
            if (item.actif) {
                if (window.confirm(`Le type "${item.nom}" est actif. Désactiver plutôt que supprimer ?`))
                    toggleActif(item);
            } else {
                if (window.confirm(`Supprimer définitivement "${item.nom}" ?`))
                    dispatch(deleteAbsenceTypeRequest(item.id));
            }
        }
        if (type === "justificatif") {
            if (window.confirm("Supprimer cette règle de justificatif ?"))
                dispatch(deleteJustifRuleRequest(item.id));
        }
    };

    /* â”€â”€ wizard validation â”€â”€ */
    const validateStep = (step) => {
        const errs = {};
        if (step === 0) {
            if (!formData.nom?.trim()) errs.nom = "Requis";
            if (!formData.code?.trim()) errs.code = "Requis";
        }
        if (step === 1) {
            if (formData.acquisitionMethod === "FIXED" && !formData.nbJours)
                errs.nbJours = "Requis";
            if (formData.acquisitionMethod === "ACCRUED") {
                if (!formData.joursParPeriode) errs.joursParPeriode = "Requis";
                if (!formData.plafondAnnuel) errs.plafondAnnuel = "Requis";
            }
        }
        setStepErrors(errs);
        return Object.keys(errs).length === 0;
    };

    const goNext = () => {
        if (validateStep(wizardStep))
            setWizardStep(s => Math.min(s + 1, WIZARD_STEPS.length - 1));
    };

    const goPrev = () => {
        setStepErrors({});
        setWizardStep(s => Math.max(s - 1, 0));
    };

    /* â”€â”€ submit â”€â”€ */
    const handleSubmit = (e) => {
        if (e && e.preventDefault) e.preventDefault();


        if (!validateStep(wizardStep)) return;

        const isEdit = !!editItem?.id;

        if (modalType === "typeAbsence") {
            const payload = {
                nom: formData.nom || "",
                code: formData.code || "",
                description: formData.description || "",
                couleur: formData.couleur || "#204385",
                remunere: !!formData.remunere,
                impactAcquisition: !!formData.impactAcquisition,
                actif: isEdit ? !!formData.actif : true,
                allowReschedule: formData.allowReschedule !== undefined ? !!formData.allowReschedule : true,
                reschedulePolicy: formData.reschedulePolicy || "APRES_VALIDATION",
                periodeDe: formData.periodeDe || null,
                periodeA: formData.periodeA || null,
                acquisitionMethod: formData.acquisitionMethod || "FIXED",
                balanceType: formData.balanceType || "ANNUAL",
                nbJours: formData.nbJours ? Number(formData.nbJours) : null,
                methode: formData.methode || "Mensuel",
                joursParPeriode: formData.joursParPeriode ? Number(formData.joursParPeriode) : null,
                plafondAnnuel: formData.plafondAnnuel ? Number(formData.plafondAnnuel) : null,
                reportMax: formData.reportMax ? Number(formData.reportMax) : null,
                perteNonPris: !!formData.perteNonPris,
                dayType: formData.dayType || "WORKDAY",
                prorataCalculation: !!formData.prorataCalculation,
                justificationRequired: !!formData.justificationRequired,
                justificationType: formData.justificationType || "",
                noticePeriod: Number(formData.noticePeriod || 0),
                negativeBalanceAllowed: !!formData.negativeBalanceAllowed,
                maxNegativeBalance: Number(formData.maxNegativeBalance || 0),
                maxDaysPerRequest: formData.maxDaysPerRequest ? Number(formData.maxDaysPerRequest) : null,
                seniorityTiers: (formData.seniorityTiers || []).map(t => ({
                    minYears: Number(t.minYears),
                    maxYears: Number(t.maxYears),
                    days: Number(t.days),
                })),
                feedingDay: formData.feedingDay ? Number(formData.feedingDay) : null,
                feedingMonth: formData.feedingMonth ? Number(formData.feedingMonth) : null,
            };
            if (isEdit) dispatch(updateAbsenceTypeRequest(editItem.id, payload));
            else dispatch(createAbsenceTypeRequest(payload));
        }



        closeModal();
    };

    const modalConfig = useMemo(() => {
        const typeOptions = (typesAbsences || []).map(t => ({ id: t.id, nom: t.nom }));
        return {
            typeAbsence: { title: "type d'absence" },

        };
    }, [typesAbsences]);

    /* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
       WIZARD STEP RENDERERS
    â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */

    const renderStepBase = () => (
        <div className="pcWizStep" key="base">
            <div className="pcWizStep__intro">
                <div className="pcWizStep__introIcon"><Settings size={20} /></div>
                <div>
                    <div className="pcWizStep__introTitle">Identité du type d'absence</div>
                    <div className="pcWizStep__introSub">Ces informations seront visibles par tous les collaborateurs.</div>
                </div>
            </div>

            <div className="pcWizGrid">
                {/* Color swatch + name */}
                <div className="pcWizField is-full">
                    <label>Nom du type <span className="pcReq">*</span></label>
                    <div className="pcColorInput">
                        <input
                            type="color"
                            className="pcColorSwatch"
                            value={formData.couleur || "#204385"}
                            onChange={e => set("couleur", e.target.value)}
                            title="Couleur"
                        />
                        <input
                            type="text"
                            className={`pcInput ${stepErrors.nom ? "is-error" : ""}`}
                            placeholder="ex: Congés payés, RTT, Maladie¦"
                            value={formData.nom || ""}
                            onChange={e => set("nom", e.target.value)}
                        />
                        {formData.nom && (
                            <span className="pcCodePreview" style={{ background: formData.couleur || "#204385" }}>
                                {formData.code || "???"}
                            </span>
                        )}
                    </div>
                    {stepErrors.nom && <span className="pcErrMsg">{stepErrors.nom}</span>}
                </div>

                <div className="pcWizField">
                    <label>Code <span className="pcReq">*</span> <Tip text="Identifiant court (ex: CP, RTT, MAL)" /></label>
                    <input
                        type="text"
                        className={`pcInput ${stepErrors.code ? "is-error" : ""}`}
                        placeholder="CP"
                        maxLength={8}
                        value={formData.code || ""}
                        onChange={e => set("code", e.target.value.toUpperCase())}
                    />
                    {stepErrors.code && <span className="pcErrMsg">{stepErrors.code}</span>}
                </div>

                <div className="pcWizField">
                    <label>Statut</label>
                    <div className="pcToggleRow">
                        <Toggle
                            checked={!!formData.actif}
                            onChange={v => set("actif", v)}
                            disabled={loading}
                        />
                        <span className={`pcToggleStatus ${formData.actif ? "is-on" : ""}`}>
                            {formData.actif ? "Actif" : "Inactif"}
                        </span>
                    </div>
                </div>

                <div className="pcWizField is-full">
                    <label>Description</label>
                    <textarea
                        className="pcInput pcInput--textarea"
                        rows={2}
                        placeholder="Description optionnelle pour les RH"
                        value={formData.description || ""}
                        onChange={e => set("description", e.target.value)}
                    />
                </div>
            </div>

            {/* Live preview */}
            {(formData.nom || formData.code) && (
                <div className="pcPreview">
                    <div className="pcPreview__label">AperÃ§u</div>
                    <div className="pcPreview__badge" style={{ borderColor: formData.couleur || "#204385", color: formData.couleur || "#204385" }}>
                        <span className="pcPreview__dot" style={{ background: formData.couleur || "#204385" }} />
                        {formData.nom || "Nom du type"}
                        {formData.code && (
                            <span className="pcPreview__code" style={{ background: formData.couleur || "#204385" }}>
                                {formData.code}
                            </span>
                        )}
                    </div>
                </div>
            )}
        </div>
    );

    const renderStepAcquisition = () => (
        <div className="pcWizStep" key="acquisition">
            <div className="pcWizStep__intro">
                <div className="pcWizStep__introIcon"><Layers size={20} /></div>
                <div>
                    <div className="pcWizStep__introTitle">Règles d'acquisition</div>
                    <div className="pcWizStep__introSub">Comment les jours sont-ils attribués aux collaborateurs ?</div>
                </div>
            </div>

            {/* Acquisition method */}
            <div className="pcCardGroup">
                <div className="pcCardGroup__label">Type d'attribution</div>
                <div className="pcMethodCards">
                    {[
                        { val: "FIXED", title: "Dotation fixe",         desc: "Montant forfaitaire par an. Ex : mariage, naissance, événementiel." },
                        { val: "ACCRUED", title: "Acquisition progressive", desc: "Cumul mensuel ou annuel. Ex : congés payés, RTT." },
                    ].map(m => (
                        <button
                            key={m.val}
                            type="button"
                            className={`pcMethodCard ${formData.acquisitionMethod === m.val ? "is-active" : ""}`}
                            onClick={() => set("acquisitionMethod", m.val)}
                        >
                            <span className="pcMethodCard__icon">{m.icon}</span>
                            <span className="pcMethodCard__title">{m.title}</span>
                            <span className="pcMethodCard__desc">{m.desc}</span>
                            <span className="pcMethodCard__check"><Check size={14} /></span>
                        </button>
                    ))}
                </div>
            </div>

            {/* Balance type */}
            <div className="pcCardGroup" style={{ marginTop: 20 }}>
                <div className="pcCardGroup__label">Cycle du solde</div>
                <div className="pcPillTabs">
                    {[
                        { val: "ANNUAL", label: "Annuel", desc: "Réinitialisation chaque année civile" },
                        { val: "GLOBAL", label: "Permanent", desc: "Solde cumulatif sans expiration" },
                    ].map(b => (
                        <button
                            key={b.val}
                            type="button"
                            className={`pcPillTab ${formData.balanceType === b.val ? "is-active" : ""}`}
                            onClick={() => set("balanceType", b.val)}
                        >
                            <span className="pcPillTab__label">{b.label}</span>
                            <span className="pcPillTab__desc">{b.desc}</span>
                        </button>
                    ))}
                </div>
            </div>

            {/* Conditional fields */}
            <div className="pcWizGrid" style={{ marginTop: 20 }}>
                {formData.acquisitionMethod === "FIXED" ? (
                    <div className="pcWizField">
                        <label>Jours attribués <span className="pcReq">*</span></label>
                        <div className="pcNumInput">
                            <button type="button" onClick={() => set("nbJours", Math.max(0, (formData.nbJours || 0) - 1))}><Minus size={14} /></button>
                            <input
                                type="number"
                                className={`pcInput pcInput--center ${stepErrors.nbJours ? "is-error" : ""}`}
                                value={formData.nbJours || ""}
                                onChange={e => set("nbJours", Number(e.target.value))}
                                min={0}
                            />
                            <button type="button" onClick={() => set("nbJours", (Number(formData.nbJours) || 0) + 1)}><Plus size={14} /></button>
                        </div>
                        {stepErrors.nbJours && <span className="pcErrMsg">{stepErrors.nbJours}</span>}
                    </div>
                ) : (
                    <>
                        <div className="pcWizField">
                            <label>Fréquence</label>
                            <div className="pcSelectWrap">
                                <select className="pcInput" value={formData.methode || "Mensuel"} onChange={e => set("methode", e.target.value)}>
                                    <option value="Mensuel">Mensuel</option>
                                    <option value="Annuel">Annuel</option>
                                </select>
                            </div>
                        </div>
                        <div className="pcWizField">
                            <label>Jours / période <span className="pcReq">*</span></label>
                            <input
                                type="number" step="0.01"
                                className={`pcInput ${stepErrors.joursParPeriode ? "is-error" : ""}`}
                                value={formData.joursParPeriode || ""}
                                onChange={e => set("joursParPeriode", Number(e.target.value))}
                            />
                            {stepErrors.joursParPeriode && <span className="pcErrMsg">{stepErrors.joursParPeriode}</span>}
                        </div>
                        <div className="pcWizField">
                            <label>Plafond annuel (j) <span className="pcReq">*</span></label>
                            <input
                                type="number"
                                className={`pcInput ${stepErrors.plafondAnnuel ? "is-error" : ""}`}
                                value={formData.plafondAnnuel || ""}
                                onChange={e => set("plafondAnnuel", Number(e.target.value))}
                            />
                            {stepErrors.plafondAnnuel && <span className="pcErrMsg">{stepErrors.plafondAnnuel}</span>}
                        </div>
                        <div className="pcWizField">
                            <label>Calcul au prorata</label>
                            <div className="pcToggleRow">
                                <Toggle checked={!!formData.prorataCalculation} onChange={v => set("prorataCalculation", v)} disabled={loading} />
                                <span className="pcToggleHint">Ajuster selon date d'entrée</span>
                            </div>
                        </div>

                        {/* Reference period */}
                        <div className="pcWizField is-full">
                            <div className="pcInlineGroup">
                                <Toggle
                                    checked={!!formData.useReferencePeriod || !!formData.periodeDe}
                                    onChange={v => setFormData(p => ({ ...p, useReferencePeriod: v, periodeDe: v ? p.periodeDe : null, periodeA: v ? p.periodeA : null }))}
                                    disabled={loading}
                                />
                                <span className="pcToggleHint" style={{ fontWeight: 600 }}>Période de référence personnalisée</span>
                            </div>
                        </div>

                        {(formData.useReferencePeriod || !!formData.periodeDe) && (
                            <>
                                <div className="pcWizField">
                                    <label>Du</label>
                                    <input type="date" className="pcInput" value={formData.periodeDe || ""} onChange={e => set("periodeDe", e.target.value)} required />
                                </div>
                                <div className="pcWizField">
                                    <label>Au</label>
                                    <input type="date" className="pcInput" value={formData.periodeA || ""} onChange={e => set("periodeA", e.target.value)} required />
                                </div>
                            </>
                        )}
                    </>
                )}

                {/* Feeding Date / Day */}
                <div className="pcWizField is-full">
                    <div className="pcCardGroup" style={{ marginTop: 10 }}>
                        <div className="pcCardGroup__label" style={{ marginBottom: 12 }}>
                            {formData.acquisitionMethod === "FIXED" ? "Date de l'alimentation annuelle" : "Jour de l'alimentation mensuelle"}
                        </div>
                        <div className="pcWizGrid">
                            {formData.acquisitionMethod === "FIXED" ? (
                                <>
                                    <div className="pcWizField">
                                        <label>Jour <span className="pcReq">*</span></label>
                                        <div className="pcSelectWrap">
                                            <select className="pcInput" value={formData.feedingDay || ""} onChange={e => set("feedingDay", e.target.value)}>
                                                <option value="">Choisir...</option>
                                                {[...Array(31)].map((_, i) => (
                                                    <option key={i + 1} value={i + 1}>{i + 1}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="pcWizField">
                                        <label>Mois <span className="pcReq">*</span></label>
                                        <div className="pcSelectWrap">
                                            <select className="pcInput" value={formData.feedingMonth || ""} onChange={e => set("feedingMonth", e.target.value)}>
                                                <option value="">Choisir...</option>
                                                {[
                                                    "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
                                                    "Juillet", "AoÃ»t", "Septembre", "Octobre", "Novembre", "Décembre"
                                                ].map((m, i) => (
                                                    <option key={i + 1} value={i + 1}>{m}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <div className="pcWizField">
                                    <label>Chaque mois, le : <span className="pcReq">*</span></label>
                                    <div className="pcSelectWrap">
                                        <select className="pcInput" value={formData.feedingDay || ""} onChange={e => set("feedingDay", e.target.value)}>
                                            <option value="">Choisir...</option>
                                            {[...Array(31)].map((_, i) => (
                                                <option key={i + 1} value={i + 1}>{i + 1}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <span className="pcToggleHint" style={{ marginTop: 5 }}>Ex: Le 5 de chaque mois</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {formData.balanceType === "ANNUAL" && (
                    <div className="pcWizField is-full">
                        <div className="pcInfoBox pcInfoBox--warn" style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: '20px',
                            padding: '12px 15px'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
                                <Toggle
                                    checked={!!formData.perteNonPris}
                                    onChange={v => set("perteNonPris", v)}
                                    disabled={loading}
                                />
                                <div>
                                    <div style={{ fontWeight: 600, fontSize: 12 }}>Perte en fin de période</div>
                                    <div style={{ fontSize: 11, color: "#64748b" }}>Les jours non consommés sont perdus.</div>
                                </div>
                            </div>

                            {formData.perteNonPris && (
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    paddingLeft: '20px',
                                    borderLeft: '1px solid rgba(0,0,0,0.1)'
                                }}>
                                    <label style={{ fontSize: '11px', fontWeight: 600, color: '#475569', marginBottom: 0, whiteSpace: 'nowrap' }}>
                                        Report max (j)
                                    </label>
                                    <div className="pcNumInput" style={{ width: '110px' }}>
                                        <button type="button" onClick={() => set("reportMax", Math.max(0, (formData.reportMax || 0) - 1))}><Minus size={12} /></button>
                                        <input
                                            type="number" min="0"
                                            className="pcInput pcInput--center"
                                            style={{ height: '28px', fontSize: '12px' }}
                                            placeholder="0"
                                            value={formData.reportMax ?? 0}
                                            onChange={e => set("reportMax", e.target.value ? Number(e.target.value) : 0)}
                                        />
                                        <button type="button" onClick={() => set("reportMax", (Number(formData.reportMax) || 0) + 1)}><Plus size={12} /></button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>

            {/* Seniority tiers */}
            <div className="pcTiers" style={{ marginTop: 20 }}>
                <div className="pcTiers__header">
                    <span>Paliers d'ancienneté <Tip text="Modulez le nombre de jours selon l'ancienneté du collaborateur." /></span>
                    <button
                        type="button"
                        className="pcMiniBtn"
                        onClick={() => setFormData(p => ({
                            ...p,
                            seniorityTiers: [...(p.seniorityTiers || []), { minYears: 0, maxYears: 5, days: 20 }],
                        }))}
                    >
                        <Plus size={12} /> Ajouter un palier
                    </button>
                </div>
                <div className="pcTiers__list">
                    {(formData.seniorityTiers || []).length === 0 ? (
                        <div className="pcEmptyTiers">Aucune règle d'ancienneté.</div>
                    ) : (
                        (formData.seniorityTiers || []).map((tier, idx) => (
                            <div key={idx} className="pcTierRow">
                                <span className="pcTierLabel">De</span>
                                <input
                                    type="number"
                                    value={tier.minYears}
                                    onChange={e => {
                                        const t = [...formData.seniorityTiers];
                                        t[idx] = { ...t[idx], minYears: Number(e.target.value) };
                                        set("seniorityTiers", t);
                                    }}
                                />
                                <span className="pcTierLabel">à</span>
                                <input
                                    type="number"
                                    value={tier.maxYears}
                                    onChange={e => {
                                        const t = [...formData.seniorityTiers];
                                        t[idx] = { ...t[idx], maxYears: Number(e.target.value) };
                                        set("seniorityTiers", t);
                                    }}
                                />
                                <span className="pcTierLabel">ans </span>
                                <input
                                    className="pcTierDays"
                                    type="number"
                                    value={tier.days}
                                    onChange={e => {
                                        const t = [...formData.seniorityTiers];
                                        t[idx] = { ...t[idx], days: Number(e.target.value) };
                                        set("seniorityTiers", t);
                                    }}
                                />
                                <span className="pcTierLabel">jours</span>
                                <button
                                    type="button"
                                    className="pcTierDel"
                                    onClick={() => set("seniorityTiers", formData.seniorityTiers.filter((_, i) => i !== idx))}
                                >
                                    <Minus size={13} />
                                </button>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );

    const renderStepRules = () => (
        <div className="pcWizStep" key="rules">
            <div className="pcWizStep__intro">
                <div className="pcWizStep__introIcon"><Shield size={20} /></div>
                <div>
                    <div className="pcWizStep__introTitle">Rémunération & report</div>
                    <div className="pcWizStep__introSub">Règles de paie et de report liées au type d'absence.</div>
                </div>
            </div>
            <div className="pcWizGrid" style={{ marginTop: 20 }}>
                {/* Remunere */}
                <div className="pcWizField">
                    <label>Rémunération</label>
                    <div className="pcInfoBox">
                        <Toggle checked={!!formData.remunere} onChange={v => set("remunere", v)} disabled={loading} />
                        <div>
                            <div style={{ fontWeight: 600, fontSize: 12 }}>Absence rémunérée</div>
                            <div style={{ fontSize: 11, color: "#64748b" }}>Le salaire est maintenu pendant cette absence.</div>
                        </div>
                    </div>
                </div>

                {/* Reschedule */}
                <div className="pcWizField is-full">
                    <label>Report de congés</label>
                    <div className="pcInfoBox">
                        <Toggle checked={!!formData.allowReschedule} onChange={v => set("allowReschedule", v)} disabled={loading} />
                        <div>
                            <div style={{ fontWeight: 600, fontSize: 12 }}>Autoriser le report</div>
                            <div style={{ fontSize: 11, color: "#64748b" }}>Le collaborateur peut déplacer une demande validée.</div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );

    const renderStepConstraints = () => (
        <div className="pcWizStep" key="constraints">
            <div className="pcWizStep__intro">
                <div className="pcWizStep__introIcon"><Calendar size={20} /></div>
                <div>
                    <div className="pcWizStep__introTitle">Restrictions & Justificatifs</div>
                    <div className="pcWizStep__introSub">Règles d'utilisation, délais et documents obligatoires.</div>
                </div>
            </div>

            <div className="pcWizGrid">
                {/* Day type */}
                {/*<div className="pcWizField is-full">*/}
                {/*    <label>Type de décompte des jours</label>*/}
                {/*    <div className="pcPillTabs">*/}
                {/*        {[*/}
                {/*            { val: "WORKDAY",  label: "Jours ouvrés",     desc: "Lunâ€“Ven, hors fériés" },*/}
                {/*            { val: "CALENDAR", label: "Jours calendaires", desc: "7 jours / 7" },*/}
                {/*        ].map(d => (*/}
                {/*            <button*/}
                {/*                key={d.val}*/}
                {/*                type="button"*/}
                {/*                className={`pcPillTab ${formData.dayType === d.val ? "is-active" : ""}`}*/}
                {/*                onClick={() => set("dayType", d.val)}*/}
                {/*            >*/}
                {/*                <span className="pcPillTab__label">{d.label}</span>*/}
                {/*                <span className="pcPillTab__desc">{d.desc}</span>*/}
                {/*            </button>*/}
                {/*        ))}*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/* Notice period */}
                <div className="pcWizField">
                    <label>Préavis (jours) <Tip text="Délai minimum avant la date de début de l'absence." /></label>
                    <div className="pcNumInput">
                        <button type="button" onClick={() => set("noticePeriod", Math.max(0, (formData.noticePeriod || 0) - 1))}><Minus size={14} /></button>
                        <input
                            type="number" min="0"
                            className="pcInput pcInput--center"
                            value={formData.noticePeriod || 0}
                            onChange={e => set("noticePeriod", Number(e.target.value))}
                        />
                        <button type="button" onClick={() => set("noticePeriod", (Number(formData.noticePeriod) || 0) + 1)}><Plus size={14} /></button>
                    </div>
                </div>

                {/* Max days per request */}
                <div className="pcWizField">
                    <label>Max jours par prise <Tip text="Nombre maximum de jours autorisés pour une seule demande." /></label>
                    <div className="pcNumInput">
                        <button type="button" onClick={() => set("maxDaysPerRequest", Math.max(0, (formData.maxDaysPerRequest || 0) - 1))}><Minus size={14} /></button>
                        <input
                            type="number" min="0"
                            className="pcInput pcInput--center"
                            placeholder="Aucun"
                            value={formData.maxDaysPerRequest || ""}
                            onChange={e => set("maxDaysPerRequest", e.target.value ? Number(e.target.value) : null)}
                        />
                        <button type="button" onClick={() => set("maxDaysPerRequest", (Number(formData.maxDaysPerRequest) || 0) + 1)}><Plus size={14} /></button>
                    </div>
                </div>

                {/* Negative balance */}
                <div className="pcWizField">
                    <label>Solde négatif autorisé</label>
                    <div className="pcToggleRow">
                        <Toggle checked={!!formData.negativeBalanceAllowed} onChange={v => set("negativeBalanceAllowed", v)} disabled={loading} />
                    </div>
                </div>

                {formData.negativeBalanceAllowed && (
                    <div className="pcWizField">
                        <label>Seuil max négatif (j)</label>
                        <input
                            type="number" min="0"
                            className="pcInput"
                            value={formData.maxNegativeBalance || 0}
                            onChange={e => set("maxNegativeBalance", Number(e.target.value))}
                        />
                    </div>
                )}
            </div>
        </div>
    );

    const renderStepJustificatifs = () => (
        <div className="pcWizStep" key="justificatif">
            <div className="pcWizStep__intro">
                <div className="pcWizStep__introIcon"><FileCheck size={20} /></div>
                <div>
                    <div className="pcWizStep__introTitle">Justificatifs & Preuves</div>
                    <div className="pcWizStep__introSub">Configurez les documents requis pour ce type d'absence.</div>
                </div>
            </div>

            <div className="pcWizGrid">
                <div className="pcWizField is-full">
                    <div className="pcInfoBox" style={{ background: formData.justificationRequired ? "rgba(32, 67, 133, 0.05)" : "transparent" }}>
                        <Toggle checked={!!formData.justificationRequired} onChange={v => set("justificationRequired", v)} disabled={loading} />
                        <div>
                            <div style={{ fontWeight: 600, fontSize: 13, color: "#204385" }}>Un justificatif est nécessaire</div>
                            <div style={{ fontSize: 12, color: "#64748b" }}>Le collaborateur devra (ou pourra) joindre un document.</div>
                        </div>
                    </div>
                </div>

                {formData.justificationRequired && (
                    <>
                        <div className="pcWizField is-full">
                            <label>Intitulé du document demandé <span className="pcReq">*</span></label>
                            <input
                                type="text"
                                className={`pcInput ${stepErrors.justificationType ? "is-error" : ""}`}
                                placeholder="ex: Certificat Médical, Acte de Mariage, Convocation..."
                                value={formData.justificationType || ""}
                                onChange={e => set("justificationType", e.target.value)}
                            />
                            <div className="pcInputHint">C'est ce nom qui sera affiché au collaborateur lors de sa demande.</div>
                            {stepErrors.justificationType && <span className="pcErrMsg">{stepErrors.justificationType}</span>}
                        </div>

                        <div className="pcWizField is-full">
                            <div className="pcToggleRow" style={{ background: "#f8fafc", padding: "10px 15px", borderRadius: 8, border: "1px dashed #e2e8f0" }}>
                                <Toggle checked={!!formData.justificationMandatory} onChange={v => set("justificationMandatory", v)} disabled={loading} />
                                <div>
                                    <div style={{ fontWeight: 600, fontSize: 12 }}>Rendre le dépôt obligatoire</div>
                                    <div style={{ fontSize: 11, color: "#64748b" }}>La demande ne pourra pas être soumise sans fichier joint.</div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );

    const renderRecap = () => (
        <div className="pcRecap">
            <div className="pcRecap__label">Récapitulatif</div>
            <div className="pcRecap__grid">
                <div className="pcRecap__item">
                    <span className="pcRecap__key">Nom</span>
                    <span className="pcRecap__val" style={{ color: formData.couleur }}>
                        {formData.nom || "-"}
                    </span>
                </div>
                <div className="pcRecap__item">
                    <span className="pcRecap__key">Code</span>
                    <span className="pcRecap__val">
                        {formData.code
                            ? <span className="pcCode" style={{ background: formData.couleur }}>{formData.code}</span>
                            : "-"}
                    </span>
                </div>
                <div className="pcRecap__item">
                    <span className="pcRecap__key">Acquisition</span>
                    <span className="pcRecap__val">
                        {formData.acquisitionMethod === "FIXED"
                            ? `${formData.nbJours || "?"} j fixe`
                            : `${formData.joursParPeriode || "?"} j / ${formData.methode}`}
                    </span>
                </div>
                <div className="pcRecap__item">
                    <span className="pcRecap__key">Décompte</span>
                    <span className="pcRecap__val">
                        {{ WORKDAY: "Jours ouvrés", CALENDAR: "Calendaires" }[formData.dayType] || "-"}
                    </span>
                </div>
                <div className="pcRecap__item">
                    <span className="pcRecap__key">Rémunéré</span>
                    <span className="pcRecap__val">{formData.remunere ? "Oui" : "Non"}</span>
                </div>
                <div className="pcRecap__item">
                    <span className="pcRecap__key">Perte/Report</span>
                    <span className="pcRecap__val">
                        {formData.perteNonPris
                            ? (formData.reportMax > 0 ? `Perte (max ${formData.reportMax}j reportables)` : "Perte totale")
                            : "Report intégral"}
                    </span>
                </div>
                <div className="pcRecap__item">
                    <span className="pcRecap__key">Justificatif</span>
                    <span className="pcRecap__val">
                        {formData.justificationRequired ? `${formData.justificationType || "Requis"}` : "Non"}
                    </span>
                </div>
                {formData.justificationRequired && (
                    <div className="pcRecap__item">
                        <span className="pcRecap__key">Obligatoire</span>
                        <span className="pcRecap__val">{formData.justificationMandatory ? "Oui" : "Optionnel"}</span>
                    </div>
                )}
            </div>
        </div>
    );

    const wizardStepRenderers = [
        renderStepBase,
        renderStepAcquisition,
        renderStepRules,
        renderStepConstraints,
        renderStepJustificatifs,
    ];

    /* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
       JUSTIFICATIF SIMPLE FORM
    â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
    const renderSimpleForm = () => {
        const config = modalConfig[modalType];
        if (!config) return null;
        return (
            <div className="pcForm">
                {config.fields.map((field) => (
                    <div className="pcField" key={field.name}>
                        <label>{field.label}</label>
                        {field.type === "selectId" ? (
                            <select
                                className="pcInput"
                                value={formData[field.name] || ""}
                                onChange={e => set(field.name, e.target.value)}
                                required={field.required}
                            >
                                <option value="">Sélectionner</option>
                                {(field.options || []).map(opt => (
                                    <option key={opt.id} value={opt.id}>{opt.nom}</option>
                                ))}
                            </select>
                        ) : field.type === "checkbox" ? (
                            <div className="pcToggleRow">
                                <Toggle
                                    checked={!!formData[field.name]}
                                    onChange={v => set(field.name, v)}
                                    disabled={loading}
                                />
                            </div>
                        ) : (
                            <input
                                type={field.type}
                                className="pcInput"
                                value={formData[field.name] ?? ""}
                                onChange={e => set(field.name, field.type === "number" ? Number(e.target.value) : e.target.value)}
                                required={field.required}
                            />
                        )}
                    </div>
                ))}
            </div>
        );
    };

    /* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
       RENDER MODAL
    â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
    const renderModal = () => {
        if (!showModal) return null;
        const config = modalConfig[modalType];
        if (!config) return null;
        const isEdit = !!editItem?.id;
        const isWizard = modalType === "typeAbsence";
        const isLastStep = wizardStep === WIZARD_STEPS.length - 1;

        return (
            <div className="pcModal" onClick={e => e.target === e.currentTarget && closeModal()}>
                <div className={`pcModal__panel ${isWizard ? "pcModal__panel--wide" : ""}`} role="dialog" aria-modal="true">

                    {/* Header */}
                    <div className="pcModal__header">
                        <div className="pcModal__headerLeft">
                            <div className="pcModal__title">
                                {isEdit ? "Modifier" : "Nouveau"} {config.title}
                            </div>
                            {isWizard && (
                                <div className="pcModal__subtitle">
                                    Ã‰tape {wizardStep + 1} sur {WIZARD_STEPS.length} {WIZARD_STEPS[wizardStep].label}
                                </div>
                            )}
                        </div>
                        <button className="pcIconBtn pcIconBtn--close" onClick={closeModal} type="button" aria-label="Fermer">
                            <X size={16} />
                        </button>
                    </div>

                    {/* Wizard stepper */}
                    {isWizard && (
                        <div className="pcStepper">
                            {WIZARD_STEPS.map((step, idx) => {
                                const Icon = step.icon;
                                const isDone = idx < wizardStep;
                                const isActive = idx === wizardStep;
                                return (
                                    <React.Fragment key={step.id}>
                                        <button
                                            type="button"
                                            className={`pcStep ${isActive ? "is-active" : ""} ${isDone ? "is-done" : ""}`}
                                            onClick={() => isDone && setWizardStep(idx)}
                                        >
                                            <div className="pcStep__circle">
                                                {isDone ? <Check size={13} /> : <Icon size={13} />}
                                            </div>
                                            <div className="pcStep__info">
                                                <span className="pcStep__label">{step.label}</span>
                                                <span className="pcStep__desc">{step.desc}</span>
                                            </div>
                                        </button>
                                        {idx < WIZARD_STEPS.length - 1 && (
                                            <div className={`pcStep__connector ${isDone ? "is-done" : ""}`} />
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    )}

                    {/* âœ… FIX : form ne soumet JAMAIS tout seul */}
                    <form onSubmit={e => e.preventDefault()}>
                        <div className="pcModal__body">
                            {isWizard ? (
                                <>
                                    {wizardStepRenderers[wizardStep]()}
                                    {/*{renderRecap()}*/}
                                </>
                            ) : (
                                renderSimpleForm()
                            )}
                        </div>

                        <div className="pcModal__footer">
                            <button className="pcBtn pcBtn--ghost" type="button" onClick={closeModal} disabled={loading}>
                                Annuler
                            </button>

                            {isWizard ? (
                                <div className="pcFooterNav">
                                    {wizardStep > 0 && (
                                        <button className="pcBtn pcBtn--outline" type="button" onClick={goPrev} disabled={loading}>
                                            <ChevronLeft size={15} /> Précédent
                                        </button>
                                    )}
                                    {!isLastStep ? (
                                        <button className="pcBtn pcBtn--primary" type="button" onClick={goNext} disabled={loading}>
                                            Suivant <ChevronRight size={15} />
                                        </button>
                                    ) : (
                                        // âœ… FIX : type="button" + onClick explicite, jamais type="submit"
                                        <button
                                            className="pcBtn pcBtn--success"
                                            type="button"
                                            onClick={handleSubmit}
                                            disabled={loading}
                                        >
                                            <Check size={15} /> {isEdit ? "Enregistrer" : "Créer le type"}
                                        </button>
                                    )}
                                </div>
                            ) : (
                                // Pour justificatif (form simple) : on garde type="button" + onClick
                                <button
                                    className="pcBtn pcBtn--primary"
                                    type="button"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    {isEdit ? "Enregistrer" : "Ajouter"}
                                </button>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        );
    };

    const renderViewModal = () => {
        if (!viewItem) return null;
        const v = viewItem;

        const Section = ({ icon: Icon, title, children }) => (
            <div className="pvSection">
                <div className="pvSection__header">
                    <Icon size={14} />
                    <span>{title}</span>
                </div>
                <div className="pvSection__body">{children}</div>
            </div>
        );

        const Row = ({ label, value }) => (
            <div className="pvRow">
                <span className="pvRow__key">{label}</span>
                <span className="pvRow__val">{value}</span>
            </div>
        );

        return (
            <div className="pcModal" onClick={e => e.target === e.currentTarget && setViewItem(null)}>
                <div className="pcModal__panel pcModal__panel--view" role="dialog" aria-modal="true">

                    {/* Header */}
                    <div className="pvHeader">
                        <div className="pvHeader__left">
                            <div className="pvHeader__dot" style={{ background: v.couleur }} />
                            <div>
                                <div className="pvHeader__title">{v.nom}</div>
                                <div className="pvHeader__sub">Détails du type d'absence</div>
                            </div>
                            <span className="pcCode" style={{ background: v.couleur }}>{v.code}</span>
                            <span className={`pcPill ${v.actif ? "is-on" : "is-off"}`} style={{ cursor: "default" }}>
                            {v.actif ? "Actif" : "Inactif"}
                        </span>
                        </div>
                        <button className="pcIconBtn pcIconBtn--close" type="button" onClick={() => setViewItem(null)}>
                            <X size={16} />
                        </button>
                    </div>

                    <div className="pvBody">
                        {v.description && (
                            <div className="pvDesc">{v.description}</div>
                        )}

                        {/* Acquisition */}
                        <Section icon={Layers} title="Acquisition">
                            <Row label="Méthode"
                                 value={v.acquisitionMethod === "FIXED" ? "Dotation fixe" : "Acquisition progressive"} />
                            <Row label="Cycle du solde"
                                 value={v.balanceType === "ANNUAL" ? "Annuel" : "Permanent"} />
                            {v.acquisitionMethod === "FIXED" ? (
                                <Row label="Jours attribués" value={`${v.nbJours ?? "-"} jour(s)`} />
                            ) : (
                                <>
                                    <Row label="Fréquence" value={v.methode ?? "-"} />
                                    <Row label="Jours / période" value={`${v.joursParPeriode ?? "-"} j`} />
                                    <Row label="Plafond annuel" value={`${v.plafondAnnuel ?? "-"} j`} />
                                    {/*{v.reportMax && <Row label="Report max" value={`${v.reportMax} j`} />}*/}
                                    <Row label="Calcul au prorata" value={v.prorataCalculation ? "Oui" : "Non"} />
                                </>
                            )}
                            {v.perteNonPris && (
                                <div className="pvBadge pvBadge--warn">Perte des jours non consommés en fin de période</div>
                            )}
                            {(v.seniorityTiers && v.seniorityTiers.length > 0) && (
                                <div className="pvTiers">
                                    <div className="pvTiers__label">Paliers d'ancienneté</div>
                                    {v.seniorityTiers.map((t, i) => (
                                        <div key={i} className="pvTierRow">
                                            <span>{t.minYears} - {t.maxYears} ans</span>
                                            <span className="pvTierDays">{t.days} jours</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Section>

                        <Section icon={Shield} title="Rémunération & Report">
                            <Row label="Rémunéré" value={v.remunere ? "Oui" : "Non"} />
                            {/*<Row label="Impact acquisition" value={v.impactAcquisition ? "Oui" : "Non"} />*/}
                            <Row label="Report autorisé" value={v.allowReschedule ? "Oui" : "Non"} />
                            {v.allowReschedule && (
                                <Row label="Politique de report"
                                     value={{ AVANT_VALIDATION: "Avant validation", APRES_VALIDATION: "Après validation", LES_DEUX: "Avant et après" }[v.reschedulePolicy] ?? "-"} />
                            )}
                        </Section>

                        {/* Restrictions */}
                        <Section icon={Calendar} title="Restrictions & Justificatifs">
                            <Row label="Préavis" value={v.noticePeriod > 0 ? `${v.noticePeriod} jour(s)` : "Aucun"} />
                            <Row label="Max par prise" value={v.maxDaysPerRequest > 0 ? `${v.maxDaysPerRequest} jour(s)` : "Illimité"} />
                            <Row label="Solde négatif" value={v.negativeBalanceAllowed ? `Autorisé (max ${v.maxNegativeBalance} j)` : "Non"} />
                            <Row label="Justificatif requis" value={v.justificationRequired ? "Oui" : "Non"} />
                            {v.justificationRequired && v.justificationType && (
                                <Row label="Type de document" value={v.justificationType} />
                            )}
                            {(v.periodeDe || v.periodeA) && (
                                <Row label="Période de référence" value={`${v.periodeDe ?? "?"} - ${v.periodeA ?? "?"}`} />
                            )}
                        </Section>
                    </div>

                    {/* Footer */}
                    <div className="pcModal__footer">
                        <button className="pcBtn pcBtn--ghost" type="button" onClick={() => setViewItem(null)}>
                            Fermer
                        </button>
                        <button className="pcBtn pcBtn--primary" type="button" onClick={() => { setViewItem(null); openModal("typeAbsence", v); }}>
                            <Edit size={15} /> Modifier
                        </button>
                    </div>
                </div>
            </div>
        );
    };
    /* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
       MAIN RENDER
    â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
    return (
        <div className="pcPage">
            <div className="pcHeader">
                <div>
                    <h1>Paramétrage des congés et absences</h1>
                    <p>Configurez les types d'absences, règles d'acquisition et justificatifs.</p>
                    {error && <div style={{ marginTop: 8, color: "#b91c1c", fontWeight: 700 }}>Erreur : {error}</div>}
                </div>

                {/*<button*/}
                {/*    className="pcBtn pcBtn--ghost"*/}
                {/*    style={{ border: "1px solid #e2e8f0", backgroundColor: "white", color: "#475569" }}*/}
                {/*    onClick={() => {*/}
                {/*        Swal.fire({*/}
                {/*            title: "Initialiser la configuration ?",*/}
                {/*            text: "Cela créera les types CP et RTT avec leurs règles standard (si inexistants).",*/}
                {/*            icon: "question",*/}
                {/*            showCancelButton: true,*/}
                {/*            confirmButtonColor: "#7c3aed",*/}
                {/*            cancelButtonColor: "#94a3b8",*/}
                {/*            confirmButtonText: "Oui, initialiser",*/}
                {/*            cancelButtonText: "Annuler",*/}
                {/*        }).then(result => { if (result.isConfirmed) dispatch(initStandardConfigRequest()); });*/}
                {/*    }}*/}
                {/*    disabled={loading}*/}
                {/*>*/}
                {/*    <Sparkles size={16} style={{ color: "#7c3aed" }} /> Configuration Standard*/}
                {/*</button>*/}
            </div>

            <div className="pcWrap">
                <div className="pcCard">
                    <div className="pcBody">
                        <div>
                            <div className="pcTopRow">
                                <h2 className="pcTitle">Types d'absences paramétrables</h2>
                                <button className="pcBtn pcBtn--primary" type="button"
                                        onClick={() => openModal("typeAbsence")} disabled={loading}>
                                    <Plus size={16}/> Ajouter un type de congé
                                </button>
                            </div>

                            <div className="pcTableWrap">
                                <table className="pcTable">
                                    <thead>
                                    <tr>
                                        <th>Couleur</th>
                                        <th>Code</th>
                                        <th>Nom</th>
                                        <th>Description</th>
                                        <th>Rémunéré</th>
                                        <th>Nombre de jours</th>
                                        <th>Max/prise</th>
                                        <th>Statut</th>
                                        <th className="is-right">Actions</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {(typesAbsences || []).map(type => (
                                        <tr key={type.id}>
                                            <td>
                                                <div className="pcColorDot" style={{backgroundColor: type.couleur}}/>
                                            </td>
                                            <td>
                                                        <span className="pcCode"
                                                              style={{backgroundColor: type.couleur}}>
                                                            {type.code}
                                                        </span>
                                            </td>
                                            <td className="pcStrong">{type.nom}</td>
                                            <td className="pcMuted">{type.description || "-"}</td>
                                            <td>
                                                {type.remunere
                                                    ? <CheckCircle size={18} className="pcOk"/>
                                                    : <X size={18} className="pcOff"/>}
                                            </td>
                                            <td>
                                                {type.acquisitionMethod === "FIXED" ? (
                                                    <div className="pcStrong">{type.nbJours} j (Fixe)</div>
                                                ) : (
                                                    <div>
                                                        <div className="pcStrong">{type.joursParPeriode} j
                                                            / {type.methode}</div>
                                                        <div className="pcTiny text-muted">
                                                            Plafond : {type.plafondAnnuel}j
                                                            {type.perteNonPris && ` â€¢ Perte (Report max: ${type.reportMax || 0}j)`}
                                                        </div>
                                                    </div>
                                                )}
                                            </td>
                                            <td className="pcStrong">
                                                {type.maxDaysPerRequest ? `${type.maxDaysPerRequest} j` : "-"}
                                            </td>

                                            <td>
                                                <button
                                                    className={`pcPill ${type.actif ? "is-on" : "is-off"}`}
                                                    type="button"
                                                    onClick={() => toggleActif(type)}
                                                    disabled={loading}
                                                >
                                                    {type.actif ? "Actif" : "Inactif"}
                                                </button>
                                            </td>
                                            <td className="is-right">
                                                <div className="pcRowActions">
                                                    <button className="pcIconBtn pcIconBtn--view" type="button"
                                                            onClick={() => setViewItem(type)}
                                                            title="Voir les détails">
                                                        <Eye size={16}/>
                                                    </button>
                                                    <button className="pcIconBtn" type="button"
                                                            onClick={() => openModal("typeAbsence", type)}
                                                            disabled={loading}>
                                                        <Edit size={16}/>
                                                    </button>
                                                    <button className="pcIconBtn pcIconBtn--danger" type="button"
                                                            onClick={() => handleDelete("typeAbsence", type)}
                                                            disabled={loading}>
                                                        <Trash2 size={16}/>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {(typesAbsences || []).length === 0 && (
                                        <tr>
                                            <td colSpan={9} className="pcEmptyCell">Aucun type configuré</td>
                                        </tr>
                                    )}
                                    </tbody>
                                </table>
                            </div>
                        </div>



                    </div>
                </div>
            </div>


            {renderModal()}
            {renderViewModal()}
        </div>
    );
};

export default ParamConges;
